import FieldSet from '../../FieldSet';

import { Integrations } from './Integrations';

export class IntegrationsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [Integrations];
  }

  get title() {
    return 'Integrations';
  }
}
